import { MouseEventHandler } from "react";
import { MenuItemOption } from "../../common/components/functional/actionMenu/types";
import IconWrapper from "../../common/components/functional/icons/IconWrapper";
import { ReactComponent as MaximizeIcon } from "../../common/icons/messaging-maximize.svg";
import { ReactComponent as MinimizeIcon } from "../../common/icons/messaging-minimize.svg";
import { ToolbarAction } from "./types/common";

const PAGE_ICON_SIZE = 22;
const COMPACT_ICON_SIZE = 18;
const MENU_ICON_SIZE = 16;

const viewModeIcon = (icon: typeof MinimizeIcon, compact: boolean) => (
  <IconWrapper
    icon={icon}
    sx={{
      fontSize: compact ? COMPACT_ICON_SIZE : PAGE_ICON_SIZE,
      color: "text.secondary",
      "& path": { fill: "currentColor", fillOpacity: 1 },
    }}
  />
);

type ViewModeActionArgs = {
  t: (key: string) => string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  compact?: boolean;
};

export const getMinimizeToolbarAction = ({
  t,
  onClick,
  disabled = false,
  compact = false,
}: ViewModeActionArgs): ToolbarAction => ({
  disabled,
  onClick,
  ariaLabel: t("minimize"),
  icon: viewModeIcon(MinimizeIcon, compact),
});

export const getMaximizeToolbarAction = ({
  t,
  onClick,
  disabled = false,
  compact = false,
}: ViewModeActionArgs): ToolbarAction => ({
  disabled,
  onClick,
  ariaLabel: t("maximize"),
  icon: viewModeIcon(MaximizeIcon, compact),
});

export const getMaximizeMenuItem = ({
  t,
  onClick,
  disabled = false,
}: {
  t: (key: string) => string;
  onClick: () => void;
  disabled?: boolean;
}): MenuItemOption => ({
  key: "maximize",
  label: t("maximize"),
  disabled,
  icon: (
    <IconWrapper
      icon={MaximizeIcon}
      sx={{
        fontSize: MENU_ICON_SIZE,
        color: "text.primary",
        "& path": { fill: "currentColor", fillOpacity: 1 },
      }}
    />
  ),
  action: () => onClick(),
});
